import axios from "axios";
import { baseURL } from "../../utils/URL";
 
const onLogin = async (postData:any) => {
  try {
    const response = await axios.post(`${baseURL}/user/login`, postData);
    return response.data;
  } catch (error:any) {
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onGetOtp = async (postData:any) => {
  try {
    const response = await axios.post(`${baseURL}/otp/send/email`, postData);
    return response.data;
  } catch (error:any) {
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onResetPassword = async (postData:any) => {
  try {
    const response = await axios.post(`${baseURL}/user/reset-password`, postData);
    return response.data;
  } catch (error:any) {
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onVerifyOtp = async (postData:any) => {
  try {
    const response = await axios.post(`${baseURL}/otp/verify/email`, postData);
    return response.data;
  } catch (error:any) {
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onVerifyAccount = async (postData:any) => {
  try {
    const response = await axios.post(`${baseURL}/user/verify`, postData);
    return response.data;
  } catch (error:any) {
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onCreateUser = async (postData:CreateUserDTO) => {
  try {
    const response = await axios.post(`${baseURL}/user/create`, postData);
    return response.data;
  } catch (error:any) {
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
export { onLogin,onGetOtp, onResetPassword, onVerifyAccount,onCreateUser, onVerifyOtp };
